// Shared assets and call to action copy for the Pler Smile Dadeland landing page.

export const CTA_LABEL = 'Reserve My Free Consultation'

export const IMAGES = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/814994ee-c9e7-424e-bf78-1fefd2988cb3.jpg',
  founder: 'https://cdn.magicpatterns.com/uploads/5nHvvv1Qz2FuoQGjAzRifs/drandreina.jpg',
  caseA: 'https://cdn.magicpatterns.com/patterns/generated-images/b6a7376f-8462-4576-b8a3-037a2fc5c47f.jpg',
  caseB: 'https://cdn.magicpatterns.com/patterns/generated-images/d8f3b288-bebe-4658-96dd-b85695c5c9a7.jpg',
  caseC: 'https://cdn.magicpatterns.com/patterns/generated-images/ad612731-aba6-4110-bebd-9dd0ab2f140e.jpg',
} as const

export const BEFORE_AFTER = [
  {
    name: 'Case 01',
    detail: 'Single arch, delivered on Day 5',
    before: 'https://cdn.magicpatterns.com/uploads/841dt4TXn8U5F55UDPapac/case1-before.jpg',
    after: 'https://cdn.magicpatterns.com/uploads/4EhTQHYXPCDoDfAkBAKd7m/case1-after.jpg',
  },
  {
    name: 'Case 02',
    detail: 'Full mouth, delivered on Day 5',
    before: 'https://cdn.magicpatterns.com/uploads/tXWnoHmcYVzATPEmW9E8N6/case2-before.jpg',
    after: 'https://cdn.magicpatterns.com/uploads/bUJvkhE1oSpwJgWoUuQcrt/case2-after.jpg',
  },
  {
    name: 'Case 03',
    detail: 'Single arch, delivered on Day 5',
    before: 'https://cdn.magicpatterns.com/uploads/mCXeaa4vA7QPPUB4fcNt7r/case3-before.jpg',
    after: 'https://cdn.magicpatterns.com/uploads/atWQNZ1AwidLkpaykG8cSa/case3-after.jpg',
  },
  {
    name: 'Case 04',
    detail: 'Full mouth, delivered on Day 5',
    before: 'https://cdn.magicpatterns.com/uploads/5B7jdwpKX5HAJVP6HcZP81/case4-before.jpg',
    after: 'https://cdn.magicpatterns.com/uploads/qQAeu7FCFZkyWHvu4gQXM4/case4-after.jpg',
  },
] as const

export function scrollToForm() {
  const el = document.getElementById('reserve')
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}
